import { useState } from "react";

export const useStripePayModal = () => {
  const [openStripePayModal, setOpenStripePayModal] = useState(false);
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [publishableKey, setPublishableKey] = useState<string | null>(null);

  const handleOpenStripePayModal = (clientSecret: string, publishableKey: string) => {
    setOpenStripePayModal(true);
    setClientSecret(clientSecret);
    setPublishableKey(publishableKey);
  };

  const handleCloseStripePayModal = () => {
    setOpenStripePayModal(false);
    setClientSecret(null);
    setPublishableKey(null);
  };

  return {
    openStripePayModal,
    handleOpenStripePayModal,
    handleCloseStripePayModal,
    clientSecret,
    publishableKey,
  };
};
